import recaptcha from './_recaptcha'

export default function contactForm() {
	return {
		fullName: '',
		email: '',
		companyName: '',
		message: '',
		subscribe: false,
		consent: false,
		errors: [],
		successMessage: '',

		init() {
			// Load eagerly so the reCAPTCHA badge is visible on page load, and so the
			// token fetch at submit time is fast (script is already cached by then).
			recaptcha.loadScript(this.$el.dataset.sitekey)
		},

		async submitForm(e) {
			e.preventDefault()

			this.errors = []

			// Validate the fields
			if (!this.fullName) {
				this.errors.push('Full name is required.')
			}

			if (!this.email || !this.isValidEmail(this.email)) {
				this.errors.push('Please enter a valid email address.')
			}

			if (!this.companyName) {
				this.errors.push('Company name is required.')
			}

			if (this.$refs.contactForm.querySelector('#message') !== null) {
				if (!this.message) {
					this.errors.push('Message is required.')
				}
			}

			if (!this.consent) {
				this.errors.push('You must agree to the terms and conditions.')
			}

			if (!this.errors.length) {
				const sitekey = this.$refs.contactForm.dataset.sitekey
				const responseInput = this.$refs.contactForm.querySelector('input[name="g-recaptcha-response"]')

				try {
					responseInput.value = await recaptcha.getToken(sitekey, 'submit')
				} catch (error) {
					this.errors.push('Could not verify reCAPTCHA. Please try again.')
					return
				}

				this.errors = []

				// If validation passes, show success message
				this.successMessage = 'Your message has been sent!'
				this.clearForm()
				e.target.submit()
			}
		},

		// Clear the form after submission
		clearForm() {
			this.fullName = '';
			this.email = '';
			this.companyName = '';
			this.subscribe = false;
			this.consent = false;

			if (this.$refs.contactForm.querySelector('#message') !== null) {
				this.message = '';
			}
		},

		isValidEmail(email) {
			const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return emailPattern.test(email);
		}
	}
}
